import { Modal } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { FileManager } from '../../MediaLibrary/MediaLibrary';
import { useEffect, useState } from 'react';

import '../../../../pages/Admin/Admin.scss';
import '../AdminModal.scss';
import './MediaLibraryModal.scss';
import { useStores } from 'index';
import { isFile, Node } from '../../../../types/admin/nodes';
import { LanguageType } from 'types/languages';

type Props = {
  isModalOn: boolean;
  countryCode: LanguageType;
  onClose: () => void;
};
// TO REMOVE ONCE THE NEW LEARNING HUB DELIVERED
export const MediaLibraryModal = observer(({ isModalOn, countryCode, onClose }: Props) => {
  const fileManagerStore = useStores().mediaLibraryStore;
  const lms = useStores().learningMaterialStore;

  const [selectedFile, setSelectedFile] = useState<Node | null>(null);

  useEffect(() => {
    fileManagerStore.fetchNodes();
  }, [fileManagerStore]);

  const handleNodesSelected = (nodes: Node[]) => {
    const files = nodes.filter(isFile);

    if (files.length !== 1) {
      setSelectedFile(null);
    } else {
      setSelectedFile(files[0]);
    }
  };

  const confirm = () => {
    if (!selectedFile) return;

    let index = lms.learningMaterial.medias.findIndex((media) => media.countryCode === countryCode);
    if (index > -1) {
      lms.learningMaterial.medias.find((media) => media.countryCode === countryCode && (media.mediaId = selectedFile.id));
    } else {
      lms.learningMaterial.medias.push({
        mediaId: selectedFile.id,
        countryCode: countryCode,
      });
    }

    onClose();
  };

  return (
    <Modal
      title='File Manager'
      open={isModalOn}
      onClose={onClose}
      cancelBtn={{
        label: 'Close',
        onClick: onClose,
      }}
      confirmBtn={{
        label: 'Select',
        onClick: confirm,
        disabled: !selectedFile,
      }}
      className='admin-modal admin-file-manager-modal'
    >
      <FileManager onNodesSelected={handleNodesSelected} />
    </Modal>
  );
});
